import { render, staticRenderFns } from "./ad_channel.vue?vue&type=template&id=635ed611&scoped=true&"
import script from "./ad_channel.vue?vue&type=script&lang=js&"
export * from "./ad_channel.vue?vue&type=script&lang=js&"
import style0 from "./ad_channel.vue?vue&type=style&index=0&id=635ed611&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ed611",
  null
  
)

export default component.exports